const COMMONSTATUS_REDUCER_NAME = 'commonStatus';

export { COMMONSTATUS_REDUCER_NAME };
